import { CSSProperties } from "react";

export interface IAdUnit {
  plugin: string;
  sid: string;
  keywords?: string;
  subid?: string;
  display?: string;
  responsive?: string;
  isflt?: string;
  style?: CSSProperties;
  className?: string;
}

export const defaultAdUnit: IAdUnit = {
  plugin: "banner",
  sid: "",
  keywords: "",
  subid: "",
  responsive: "0",
  style: {},
  className: "",
};

export const defaultSkyScrapper: IAdUnit = {
  ...defaultAdUnit,
  className: "defaultSkyScrapper",
};

export const defaultAd300x250: IAdUnit = {
  ...defaultAdUnit,
  className: "adDefault300x250", // name keeps changing because of ad block rules
};
